import "./styles.css";
import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { SvgIcon } from "@mui/material";

export default function VacationItem({
  checked,
  onChecked,
  title,
  icon,
  color,
}) {
  return (
    <div
      className="check-box"
      style={{ border: "1px solid rgba(169,169,169)" }}
      id="vacation-container"
    >
      <Checkbox
        checked={checked}
        onChange={onChecked}
        inputProps={{ "aria-label": "controlled" }}
        id="vacation-check-box"
      />
      <div className="timing" id="vacation-title-container">
        <SvgIcon component={icon} sx={{ color }} id="vacation-icon" />
        <p id="vacation-title">{title}</p>
      </div>
    </div>
  );
}
